import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

import { PipelineNodeCardComponent } from '../pipeline-node-card/pipeline-node-card.component';
import { WorkflowConfig, WorkflowNode } from '../../shared-services/pipeline-workflow.model';
import { PipelineWorkflowService } from '../../shared-services/pipeline-workflow.service';

@Component({
  selector: 'app-pipeline-workflow-detail',
  standalone: true,
  imports: [CommonModule, PipelineNodeCardComponent],
  templateUrl: './pipeline-workflow-detail.component.html',
  styleUrl: './pipeline-workflow-detail.component.scss',
})
export class PipelineWorkflowDetailComponent implements OnInit, OnDestroy {
  @Input() data: any;

  config: WorkflowConfig | null = null;
  activeNode: WorkflowNode | null = null;
  activeNodeIndex = -1;

  private readonly sub = new Subscription();

  constructor(private readonly workflowService: PipelineWorkflowService) {}

  ngOnInit(): void {
    if (this.data?.workflow) {
      this.workflowService.loadConfig(this.data.workflow);
    }

    this.sub.add(this.workflowService.config$.subscribe((config) => {
      this.config = config;
      this.syncActiveNode();
    }));

    this.sub.add(this.workflowService.activeNodeId$.subscribe(() => {
      this.syncActiveNode();
    }));
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  get cardConfig(): any {
    return this.data?.nodeCard ?? {};
  }

  get emptyState(): any {
    return this.data?.emptyState ?? {};
  }

  buildCardData(): any {
    if (!this.activeNode) return null;
    return {
      node: this.activeNode,
      index: this.activeNodeIndex,
      config: this.cardConfig,
      onUpdateNode: (updatedNode: WorkflowNode) => this.workflowService.updateNode(updatedNode),
      onDeleteNode: (nodeId: string) => this.workflowService.deleteNode(nodeId),
      onDuplicateNode: (nodeId: string) => this.workflowService.duplicateNode(nodeId),
      onTestNode: (_nodeId: string) => undefined,
    };
  }

  readFlag(value: unknown, fallback: boolean): boolean {
    return typeof value === 'boolean' ? value : fallback;
  }

  readText(value: unknown, fallback: string): string {
    return typeof value === 'string' && value.trim() ? value.trim() : fallback;
  }

  private syncActiveNode(): void {
    this.activeNode = this.workflowService.activeNode;
    this.activeNodeIndex = this.workflowService.activeNodeIndex;
  }
}
